// ScrollToTop.js
import React from 'react';
import { Fab, Zoom, useScrollTrigger, Box } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ScrollToTop = ({ 
  threshold = 100, 
  position = { bottom: 16, right: 16 },
  size = "small",
  color = "primary",
  anchorId = "back-to-top-anchor"
}) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: threshold,
  });

  const handleClick = () => {
    // Method 1: Direct scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Method 2: If you want to use anchor (uncomment if needed)
    // const anchor = document.getElementById(anchorId);
    // if (anchor) {
    //   anchor.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'start',
    //   });
    // }
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ 
          position: 'fixed', 
          bottom: position.bottom, 
          right: position.right,
          zIndex: 1000,
          cursor: 'pointer'
        }}
      >
        <Fab 
          color={color} 
          size={size} 
          aria-label="scroll back to top"
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Box>
    </Zoom>
  );
};

export default ScrollToTop;